import React from 'react'
import createIcon from '@/lib/create-icon'

export const ArrowSVGIcon = createIcon(
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6663 8.49998H3.33301M3.33301 8.49998L7.99967 13.1666M3.33301 8.49998L7.99967 3.83331"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
